import { Box, Divider, IconButton, Popover, Typography } from "@mui/material";
import CrossIcon from "../../../assets/images/icons/cross.icon";
import { memo } from "react";

const PopoverDialog = ({
  title = '',
  anchorEl = null,
  align = 'right',
  onClose,
  minWidth = '300px',
  children
}) => {
  // Memoize anchor and transform origins
  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: align,
  };

  const transformOrigin = {
    vertical: 'top',
    horizontal: align,
  };

  // Memoize paper styles
  const paperStyles = {
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
  };

  const Header = title ? (
    <>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" component="div" className="py-2 px-3">
          {title}
        </Typography>
        <IconButton onClick={onClose} className="mr-1">
          <CrossIcon />
        </IconButton>
      </Box>
      <Divider />
    </>
  ) : null;

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      disablePortal
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{
        paper: {
          sx: paperStyles
        },
      }}
    >
      <Box sx={{ minWidth }}>
        {Header}
        <Box className="min-h-[50px] py-2 px-3">
          {children}
        </Box>
      </Box>
    </Popover>
  );
};

export default memo(PopoverDialog);
